import axios from "axios";

const apiLocalServer = process.env.REACT_APP_LOCAL_API_SERVER === "false";
const API = axios.create({
  // baseURL: apiLocalServer ? "http://localhost:8080/v1" : process.env.REACT_APP_API_URL,
  baseURL: process.env.REACT_APP_API_URL,
});

// Request Interceptor → Attach Token Automatically
API.interceptors.request.use(
  (config) => {
    const token = config.customToken || localStorage.getItem("token");
    // const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // redirect if not getting token
    }

    // IMPORTANT: Do NOT set content-type for FormData
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor → Redirect on Token Expire
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const httpStatus = error?.response?.status;

    // redirect to dashboard page if user access not allowed api's
    if (httpStatus === 401 || httpStatus === 403) {
      localStorage.removeItem("token");
      window.location.href = "/dashboard";
      return;
    }

    if (!error.response) {
      console.log("CORS error");
      return;
    }

    return Promise.reject(error);
  }
);

export default API;